import React from 'react';
import TreeView from '@zippytech/react-toolkit/TreeView';
import '@zippytech/react-toolkit/TreeView/index.css';
import { Grid, Input, Icon, Label } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import { debounce } from "lodash";
import ActivityTree from './ActivityTreeMenuNew';
import ContentTree from './ContentTreeMenu';
import EllipsisTooltip from '../../../common/EllipsisTooltip';
import attachedLabelToTree from '../../../../helpers/attachedLabelToTree'
import LabelWithCount from '../../../common/LabelWithCount';

@source({
  mouseEnter: (props, component) => {
    dispatch.app.setHelpContext("Playbook Development Library")
  }
})
class MyPracticeTreeMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPath: "1",
      selected: { "1": true },
      selectedId:this.props.selectedTreeId ? this.props.selectedTreeId: 11,
      pvtCategory: [],
      publicCategory: [],
      searchByName: "",
      bc: props.selectedPracticeLibrary.baseCategory ? props.selectedPracticeLibrary.baseCategory : {},
      ct: props.selectedPracticeLibrary.category ? props.selectedPracticeLibrary.category : {},
      sc: props.selectedPracticeLibrary.subCategory ? props.selectedPracticeLibrary.subCategory : {},
    };
    this.clearInput = this.clearInput.bind(this)
  }
  componentWillReceiveProps(nextProps){
    if(this.props.match.params.workspaceId !== nextProps.match.params.workspaceId){
      dispatch.lifeCycle.getCounts({ id: this.props.match.params.workspaceId })
      dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": this.props.selectedAccount._id });
      dispatch.lifeCycle.getPublicCategoryTreeAsync();
      dispatch.lifeCycle.displaySecondMenu(null);
      let pathName = `/app/${this.props.selectedAccount._id}/_ws/${this.props.match.params.workspaceId }/_pb/status/`;
      if(pathName+"playbookLibrary"== this.props.location.pathname){
        this.setState({ currentPath: "0" }) 
      }else if(pathName+"In Design"== this.props.location.pathname){
        this.setState({ currentPath: "0/0" }) 
      }else if(pathName+"underReview"==this.props.location.pathname){
        this.setState({ currentPath: "0/1" })
      }else if(pathName+"forReview"==this.props.location.pathname){
        this.setState({ currentPath: "0/1/0" })
      }else if(pathName+"inReview"==this.props.location.pathname){
        this.setState({ currentPath: "0/1/1" })
      }else if(pathName+"Approved"==this.props.location.pathname){
        this.setState({ currentPath: "0/2" })
      }else if(pathName+"Published"==this.props.location.pathname){
        this.setState({ currentPath: "0/3" })
      }else if(pathName+"Inactive"==this.props.location.pathname){
        this.setState({ currentPath: "0/4"})
      }else if(pathName+"Generating"==this.props.location.pathname){
        this.setState({ currentPath: "0/5"})
      }
    }
  }

  componentDidMount() {
    dispatch.lifeCycle.getCounts({ id: this.props.match.params.workspaceId })
    dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": this.props.selectedAccount._id });
    dispatch.lifeCycle.getPublicCategoryTreeAsync();
    dispatch.lifeCycle.displaySecondMenu(null);
    let pathName = `/app/${this.props.selectedAccount._id}/_ws/${this.props.match.params.workspaceId }/_pb/status/`;
    if(pathName+"playbookLibrary"== this.props.location.pathname){
      this.setState({ currentPath: "0" }) 
    }else if(pathName+"In Design"== this.props.location.pathname){
      this.setState({ currentPath: "0/0" }) 
    }else if(pathName+"underReview"==this.props.location.pathname){
      this.setState({ currentPath: "0/1" })
    }else if(pathName+"forReview"==this.props.location.pathname){
      this.setState({ currentPath: "0/1/0" })
    }else if(pathName+"inReview"==this.props.location.pathname){
      this.setState({ currentPath: "0/1/1" })
    }else if(pathName+"Approved"==this.props.location.pathname){
      this.setState({ currentPath: "0/2" })
    }else if(pathName+"Published"==this.props.location.pathname){
      this.setState({ currentPath: "0/3" })
    }else if(pathName+"Inactive"==this.props.location.pathname){
      this.setState({ currentPath: "0/4"})
    }else if(pathName+"Generating"==this.props.location.pathname){
      this.setState({ currentPath: "0/5"})
    }
  }

  nodeStyle = (nodeProps) => {
    if (this.state.selectedId === nodeProps.node.id ) {
      return { color: '#7FC4FA', fontFamily: 'montserrat-semibold' }
    } else {
      return { color: '#6b6b6b', fontFamily: 'montserrat-normal', fontWeight: 'normal' }
    }
  }

  async onSelectionChange(selectedMap) {
    dispatch.lifeCycle.setTreeNode({name: selectedMap.node.name, status: selectedMap.node.value})
    const history = this.props.history;
    let pathName;
    this.setState({ selected: selectedMap });
    await dispatch.lifeCycle.setSelectedTreeId(selectedMap.node.id);
    this.setState({selectedId:selectedMap.node.id})
    if (this.state.currentPath !== selectedMap.path) {
      this.setState({ currentPath: selectedMap.path });
      dispatch.lifeCycle.setTreeCurrentPath(selectedMap.path);
    }

    dispatch.app.setCollapsedResourcePaneIndexTemp(null)

    if (this.props.arrangementPaneActiveButtonFlag === 'Sequence' ||
      this.props.arrangementPaneActiveButtonFlag === 'Assign') { } else {
      await dispatch.createPack.setSelectedActivityData({});
      await dispatch.lifeCycle.setSelectedPracticeLibraryData({});

      dispatch.lifeCycle.showResourecePane(null);
      //dispatch.lifeCycle.setSelectedPracticeLibrary({});
      dispatch.lifeCycle.setArrangementPaneFlag(false);
      dispatch.lifeCycle.setPlaybookSearchQuery("");

    }

    this.setRouteAsPerState(selectedMap)

    if (
      this.props.selectedPracticeLibrary.status === 0 &&
      (this.props.arrangementPaneActiveButtonFlag === 'Sequence' ||
        this.props.arrangementPaneActiveButtonFlag === 'Assign')) {
      this.setDataAsPerCategory(selectedMap)
    } else {
      dispatch.lifeCycle.isSortingFlag({
        key: "subCategory",
        order: -1,
        text: "Sub Category"
      })
      this.goToKB(selectedMap)
    }

    dispatch.lifeCycle.getCounts({ id: this.props.selectedOrganisation.id })
    dispatch.lifeCycle.showLangingPage(false);
    dispatch.lifeCycle.setLibraryCardIndex(null)


    history.push({
      pathname: pathName
    });

  }

  componentWillUnmount() {
    dispatch.lifeCycle.showResourecePane(null);
  }

  setRouteAsPerState = async (selectedMap) => {
    let pathName;
    const history = this.props.history;
     const updateRouteAndPath = (status) => {
      dispatch.app.setRouteParams({ status }); // Update route params
      pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/status/${status}`;
    };
    await dispatch.lifeCycle.setSelectedTreeId(selectedMap.node.id);
    this.setState({selectedId:selectedMap.node.id})
    if (selectedMap.node.name === 'playbookLibrary') {
      await dispatch.lifeCycle.setCreatePracticeCard(true);
      await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"]);
      updateRouteAndPath('playbookLibrary');
      await dispatch.lifeCycle.getPacksByStatusArray({ organizationId: this.props.selectedOrganisation.id, status: this.props.filterByStatus, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role })
    //  await dispatch.lifeCycle.getPacksAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role });
      pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/status/playbookLibrary`;

    }
    else {
      dispatch.lifeCycle.setCreatePracticeCard(false);
    }

    if (selectedMap.node.value >= 0 && selectedMap.node.value <= 6) {
      await dispatch.lifeCycle.setFilterByStatus([selectedMap.node.value.toString()]);
      updateRouteAndPath(selectedMap.node.label.props.label);
      await dispatch.lifeCycle.getPacksByStatusArray({ organizationId: this.props.selectedOrganisation.id, status: this.props.filterByStatus, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role })
    //  await dispatch.lifeCycle.getPacksByStatus({ organizationId: this.props.selectedOrganisation.id, status: selectedMap.node.value, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role });
      pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/status/${selectedMap.node.label.props.label}`

    }

    if (selectedMap.node.value === 'underReview') {
      await dispatch.lifeCycle.setFilterByStatus(["1"]);
      updateRouteAndPath('underReview');
      //await dispatch.lifeCycle.getUnderReviewPacks({ organizationId: this.props.selectedOrganisation.id, user: this.props.user });
      await dispatch.lifeCycle.getPacksByStatusArray({ organizationId: this.props.selectedOrganisation.id, status: this.props.filterByStatus, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role })
      pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/status/underReview`

      dispatch.lifeCycle.setCreatePracticeCard(false);
    }

    if (selectedMap.node.value === 'inReview') {
      await dispatch.lifeCycle.setFilterByStatus(["1"]);
      updateRouteAndPath('inReview');
     // await dispatch.lifeCycle.getPacksInReview({ organizationId: this.props.selectedOrganisation.id, user: this.props.user });
     await dispatch.lifeCycle.getPacksByStatusArray({ organizationId: this.props.selectedOrganisation.id, status: this.props.filterByStatus, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role })
      pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/status/inReview`
      dispatch.lifeCycle.setCreatePracticeCard(false);

    }

    if (selectedMap.node.value === 'forReview') {
      await dispatch.lifeCycle.setFilterByStatus(["1"]);
      updateRouteAndPath('forReview');
     // await dispatch.lifeCycle.getPacksForReview({ organizationId: this.props.selectedOrganisation.id, user: this.props.user });
     await dispatch.lifeCycle.getPacksByStatusArray({ organizationId: this.props.selectedOrganisation.id, status: this.props.filterByStatus, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role })
      pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/status/forReview`
      dispatch.lifeCycle.setCreatePracticeCard(false);

    }
    if (selectedMap.node.value === 'generating') {
      updateRouteAndPath('generating');
      await dispatch.lifeCycle.setFilterByStatus(["-1"]);
     // await dispatch.lifeCycle.getPacksInReview({ organizationId: this.props.selectedOrganisation.id, user: this.props.user });
     await dispatch.lifeCycle.getPacksByStatusArray({ organizationId: this.props.selectedOrganisation.id, status: this.props.filterByStatus, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role })
      pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/status/Generating`
      dispatch.lifeCycle.setCreatePracticeCard(false);

    }
    dispatch.app.setPlaybookPath(pathName)
    history.push({
      pathname: pathName
    });
  }

  setDataAsPerCategory = async (selectedMap, name, limit, loadMoreType) => {
    let scope;

    let iPath = selectedMap && selectedMap.indexPath && selectedMap.indexPath.split('/')[0];
    if (this.props.selectedPracticeLibrary.scope === 'Private') {
      if (iPath === "1") {
        scope = "Private";
      } else if (iPath === "2") {
        scope = "Public";
      } else {
        scope = this.state.scope
      }
    }
    else {
      scope = "Public"
    }

    if (selectedMap) {
      this.setState({ searchByName: '', scope: scope })
    }


    if (selectedMap && selectedMap.node.baseCategory) {
      this.setState({
        bc: { _id: selectedMap.node._id },
        ct: {},
        sc: {}
      });
    } else if (selectedMap && selectedMap.node.category) {
      this.setState({
        bc: { _id: selectedMap.node.parent },
        ct: { _id: selectedMap.node._id },
        sc: {}
      });
    } else if (selectedMap && selectedMap.node.subCategory) {
      this.setState({
        bc: { _id: selectedMap.node.parent.split('/')[0] },
        ct: { _id: selectedMap.node.parent.split('/')[1] },
        sc: { _id: selectedMap.node._id }
      });
    } else {
      this.setState({
        bc: {},
        ct: {},
        sc: {}
      });
    }
    if (selectedMap) {
      this.setState({ displayName: selectedMap.node.label });
    }



    setTimeout(() => {

      let subCategoryArr = [];
      let nameArr = []
      if (selectedMap) {
        if (iPath === "1" && selectedMap.node.subCategory) {
          subCategoryArr = this.props.categoryTree[selectedMap.path.split('/')[1]].nodes[selectedMap.path.split('/')[2]].nodes.filter((f, i) => f.name !== "Others");
        } else if (iPath === "2" && selectedMap.node.subCategory) {
          subCategoryArr = this.props.categoryPublicTree[selectedMap.path.split('/')[1]].nodes[selectedMap.path.split('/')[2]].nodes.filter((f, i) => f.name !== "Others");
        }

        for (let i = 0; i < subCategoryArr.length; i++) {
          nameArr.push(subCategoryArr[i].name)
        }
      }


      let payload = {
        organizationId: this.props.selectedOrganisation.id,
        baseCategory: this.state.bc,
        category: this.state.ct,
        subCategory: this.state.sc,
        scope: scope ? scope : "Private",
        practiceId: this.props.selectedPracticeLibrary._id,
        referencesIdsArr: [],
        subCategoryArr: nameArr,
        // limit: limit,
        name: name ? name : this.state.searchByName
      }


      if (limit && limit !== 10) {
        payload.limit = limit
        if (loadMoreType === "content") {
          dispatch.createPack.getPublishedContentDataAsync(payload);
        } else if (loadMoreType === "activity") {
          dispatch.lifeCycle.getActivities(payload);
        }
      } else {
        dispatch.createPack.getPublishedContentDataAsync(payload);
        dispatch.lifeCycle.getActivities(payload);
      }

    }, 100);
  }

  updateData = (e, data) => {

    this.setState({ searchByName: data.value })
    this.setDataAsPerCategory(null, data.value)
    // let payload = {
    //   organizationId: this.props.selectedOrganisation.id,
    //   baseCategory: this.state.bc,
    //   category: this.state.ct,
    //   subCategory: this.state.sc,
    //   practiceId: this.props.selectedPracticeLibrary._id,
    //   name: data && data.value,
    //   scope: this.state.scope,
    //   referencesIdsArr: []
    // }

    // this.setState({ searchByName: data && data.value ? data.value : '' })
    // this.updateStateData(payload);
  }

  // updateStateData = debounce(async (payload) => {

  //   dispatch.lifeCycle.getActivities(payload);
  //   dispatch.createPack.getPublishedContentDataAsync(payload);
  // }, 300)

  goToKB = async (selectedMap) => {

    let pathName;
    let scope;
    let indexPathValue;

    let iPath = selectedMap.indexPath.split('/')[0];
    if (this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.scope === "Public") {
      scope = "Public";
      indexPathValue = "publicKnowledgeBank"
    }
    else {
      if (iPath === "1") {
        scope = "Private";
        indexPathValue = "knowledgeBank"
      } else if (iPath === "2") {
        scope = "Public";
        indexPathValue = "publicKnowledgeBank"
      } else {
        scope = null
        indexPathValue = "knowledgeBank"
      }
    }

    const payload={ organizationId: this.props.selectedOrganisation.id, status: this.props.filterByStatus, accountUserId: this.props.user._id, role: this.props.selectedOrganisation.role }
    if ((selectedMap.node.value === 'knowledgeBank' || selectedMap.node.value === 'publicKnowledgeBank') && (this.props.arrangementPaneActiveButtonFlag !== 'Sequence' || this.props.selectedPracticeLibrary.status !== 0)) {
     await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
     payload.isKnowledgeBank = true;
      //  await dispatch.lifeCycle.getAllPacksByBaseCategory({ organizationId: this.props.selectedOrganisation.id, scope: scope, user: this.props.user, role: this.props.selectedOrganisation.role }); // KLM-8964
      pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/status/${selectedMap.node.value}`;
    }
    else {
      if (selectedMap.node.baseCategory) {
      await  dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
        payload.baseCategory = selectedMap.node._id
        pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/status/${indexPathValue}/${selectedMap.node._id}`;
      }
      else if (selectedMap.node.category) {
        await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
        payload.baseCategory= selectedMap.node.parent
        payload.category= selectedMap.node._id
        pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/status/${indexPathValue}/${selectedMap.node.parent.split('/')[0]}/${selectedMap.node._id}`;
      }
      else if (selectedMap.node.subCategory) {
        let subCategoryArr = [];
        if (iPath === "1") {
          subCategoryArr = this.props.categoryTree[selectedMap.path.split('/')[1]].nodes[selectedMap.path.split('/')[2]].nodes.filter((f, i) => f.name !== "Others");
        } else if (iPath === "2") {
          subCategoryArr = this.props.categoryPublicTree[selectedMap.path.split('/')[1]].nodes[selectedMap.path.split('/')[2]].nodes.filter((f, i) => f.name !== "Others");
        }

        let nameArr = []

        for (let i = 0; i < subCategoryArr.length; i++) {
          nameArr.push(subCategoryArr[i].name)
        }
        await dispatch.lifeCycle.setFilterByStatus(["-1","0","1","2","3","4","5","10"])
        payload.baseCategory= selectedMap.node.parent.split('/')[0]
        payload.category= selectedMap.node.parent.split('/')[1]
        payload.subCategory= selectedMap.node._id
        payload.subCategoryArr= nameArr
        pathName = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/status/${indexPathValue}/${selectedMap.node.parent.split('/')[0]}/${selectedMap.node.parent.split('/')[1]}/${selectedMap.node._id}`;
      }
    }
    payload.scope = scope
    payload.status = this.props.filterByStatus;
    await dispatch.lifeCycle.getPacksByStatusArray(payload)
    const history = this.props.history;
    dispatch.app.setPlaybookPath(pathName);
    history.push({
      pathname: pathName
    });
  }






  componentWillReceiveProps(newProps) {

    if (this.props.selectedPracticeLibrary !== newProps.selectedPracticeLibrary) {

      this.setState({
        bc: null,
        ct: null,
        sc: null
      });
      // this.updateData()

    }

    if (this.props.arrangementPaneActiveButtonFlag !== newProps.arrangementPaneActiveButtonFlag) {
      if (this.state.sc && this.state.sc.name) {
        this.setState({ displayName: this.state.sc.name })
      }
      this.clearInput()
    }


    let pvtTotalCount = 0
    let publicTotalCount = 0

    if (this.props.categoryTree !== newProps.categoryTree) {
      newProps.categoryTree.map((m, i) => {
        pvtTotalCount = pvtTotalCount + m.totalPlaybookCount
        m.label = <LabelWithCount label={m.label} count={m.totalPlaybookCount} />
        if (m.nodes && m.nodes.length !== 0) {
          m.nodes.map((m1, i) => {
            m1.label = <LabelWithCount label={m1.label} count={m1.totalPlaybookCount} />
            if (m1.nodes && m1.nodes.length !== 0) {
              m1.nodes.map((m2, i) => {
                m2.label = <LabelWithCount label={m2.label} count={m2.totalPlaybookCount} />
                return m2
              })
            }
            return m1
          })
        }
        return m
      })
      this.setState({ pvtTotal: pvtTotalCount })
      this.setState({ pvtCategory: newProps.categoryTree })
    }

    if (this.props.categoryPublicTree !== newProps.categoryPublicTree) {
      newProps.categoryPublicTree.map((m, i) => {
        publicTotalCount = publicTotalCount + m.totalPlaybookCount
        m.label = <LabelWithCount label={m.label} count={m.totalPlaybookCount} />
        if (m.nodes && m.nodes.length !== 0) {
          m.nodes.map((m1, i) => {
            m1.label = <LabelWithCount label={m1.label} count={m1.totalPlaybookCount} />
            if (m1.nodes && m1.nodes.length !== 0) {
              m1.nodes.map((m2, i) => {
                m2.label = <LabelWithCount label={m2.label} count={m2.totalPlaybookCount} />
                return m2
              })
            }
            return m1
          })
        }
        return m
      })
      this.setState({ publicTotal: publicTotalCount })
      this.setState({ publicCategory: newProps.categoryPublicTree })
    }
    this.setState({selectedId : newProps.selectedTreeId});
  }

  clearInput = (e, data) => {
    let payload = {
      value: null
    }
    this.updateData(e, payload)
  }

  render() {
    const { packCount } = this.props
    let IndesignLabelWithCount = <LabelWithCount label="In Design" count={this.props.packCount[0]} />;
    let underReviewLabelWithCount = <LabelWithCount label="Review request" count={isNaN(this.props.packCount['inReview'] + this.props.packCount['forReview']) ? "" : this.props.packCount['inReview'] + this.props.packCount['forReview']} />;
    let InReviewLabelWithCount = <LabelWithCount label="Sent" count={this.props.packCount['inReview']} />;
    let ForReviewLabelWithCount = <LabelWithCount label="Received" count={this.props.packCount['forReview']} />;
    let ApprovedLabelWithCount = <LabelWithCount label="Approved" count={this.props.packCount[2]} />;
    let PublishedLabelWithCount = <LabelWithCount label="Published" count={this.props.packCount[4]} />;
    let DeprecatedLabelWithCount = <LabelWithCount label="Inactive" count={this.props.packCount[5]} />;
    let GeneratingLabelWithCount = <LabelWithCount label="Generating" count={this.props.packCount['generating']} />;

    //let totalCLC = packCount[0] + packCount['inReview'] + packCount['forReview'] + packCount[2] + packCount['publishedOwnerCount'] + packCount[5] + packCount['generating']
    let totalCLC = packCount[0] + packCount['inReview'] + packCount['forReview'] + packCount[2] + packCount[4] + packCount[5] + packCount['generating']
    const integrate = this.props.selectedAccount.integrations && this.props.selectedAccount.integrations.some(int => int.isActive && int.id.id === "openai")
    const treeList = [
      {
        label: <strong  > <LabelWithCount labelClass="bg-blue" label={`${this.props.practiceLabelName} Library`} count={totalCLC} /> </strong>,
        name: 'playbookLibrary',
        value: 'playbookLibrary',
        id: 1,
        nodes: [
          {
            label: IndesignLabelWithCount,
            name: "In Design",
            value: 0,
            id: 2,
          },
          {
            label: underReviewLabelWithCount,
            value: 'underReview',
            name: "Review Request",
            id: 3,
            nodes: [
              {
                label: ForReviewLabelWithCount,
                name: "Received",
                value: 'forReview',
                id: 4,
              },
              {
                label: InReviewLabelWithCount,
                name: "Sent",
                value: 'inReview',
                id: 5,
              }
            ]
          },
          {
            label: ApprovedLabelWithCount,
            name: "Approved",
            value: 2,
            id: 6,
          },
          {
            label: PublishedLabelWithCount,
            name: "Published",
            value: 4,
            id: 7,
          },
          {
            label: DeprecatedLabelWithCount,
            name: "Inactive",
            value: 5,
            id: 8,
          },
        ]
      }


    ];
    integrate && treeList[0].nodes.push({
      label: GeneratingLabelWithCount,
      name: "Generating",
      value: 'generating',
      id: 9,
    })


    if (this.props.selectedOrganisation.publicLibraryAccess && this.props.selectedPracticeLibrary.scope === "Public" && (this.props.arrangementPaneActiveButtonFlag === "Sequence" || this.props.arrangementPaneActiveButtonFlag === "Assign")) {
      treeList.push({
        label: <strong> <LabelWithCount labelClass="bg-blue" label="Public Library" count={this.state.publicTotal} />   </strong>,
        value: 'publicKnowledgeBank',
        nodes: this.state.publicCategory,
        id: 10,
      })
    } else {
      treeList.push({
        label: <strong> <LabelWithCount labelClass="bg-blue" label="Workspace Library" count={this.state.pvtTotal} />   </strong>,
        value: 'knowledgeBank',
        nodes: this.state.pvtCategory,
        id: 11,
      })
      if (this.props.selectedOrganisation.publicLibraryAccess){
      treeList.push({
        label: <strong> <LabelWithCount labelClass="bg-blue" label="Public Library" count={this.state.publicTotal} />   </strong>,
        value: 'publicKnowledgeBank',
        nodes: this.state.publicCategory
      })
      }
    }

    let components = attachedLabelToTree(treeList)

    let showSecondMenu = this.props.displaySecondMenu && (this.props.selectedPracticeLibrary.status === 0 || this.props.selectedPracticeLibrary.status === 4)

    return (

      <Grid divided className="practiceTree " >
        <Grid.Row className="pad_0" style={{
          height: "100%",
          overflow: "auto"
        }}>
          <Grid.Column
            // className={
            //   (this.props.displaySecondMenu === null) || (this.props.selectedPracticeLibrary.status !== 0) || (this.props.selectedPracticeLibrary.status !== 4)
            // //    && (
            // //     this.props.currentOrganization.users.some(
            // //         (el) =>
            // //             el.accountUserId === this.props.user._id &&
            // //             el.role !== "workspaceOwner"
            // //     )
            // // ))
            // ? "w_100" : "w_50"
            // }
            className={
              showSecondMenu ? "w_50" : "w_100"
            }
            style={{ height: "100%", overflow: "auto", padding: "0" }}
          >
            <TreeView
              leafNodeIcon={
                <svg fill="#000000" height="16" viewBox="0 0 24 24" width="22" style={{ verticalAlign: 'middle', overflow: 'inherit' }}>
                  <path d="M 0 10 20 10" stroke="#F6F6F6" strokeWidth="1" fill="none" />
                </svg>
              }
              className="browserPane tree-ellipsis"
              enableSelection={true}
              nodeStyle={this.nodeStyle}
              onSelectionChange={(selectedMap) => { this.onSelectionChange(selectedMap) }}
              dataSource={treeList}
              singleSelect={true}
              defaultCollapsedDepth={1}
              enableHoverStyle={false}
              enableKeyboardNavigation={false}
            />
          </Grid.Column>
          {showSecondMenu &&
            <Grid.Column
              className="practiceList visible_block  w_50"
              style={{ height: "100%", overflow: "auto", padding: "0" }}
            >
              {this.props.displaySecondMenu &&
                this.props.displaySecondMenu === "Activities"
                ?
                <span>
                  {/* <b >
                    <EllipsisTooltip
                      name={this.state.displayName}
                      style={{ margin: "10px 5px 5px"}} />
                  </b> */}

                  <Input className="pad_5 w_100"
                    onChange={this.updateData}
                    value={this.state.searchByName}
                    icon={this.state.searchByName ?
                      <Icon
                        name="close"
                        className="cursor-pointer"
                        style={{ pointerEvents: "auto" }}
                        onClick={() => this.clearInput()} /> :
                      <Icon name="search" />
                    }
                    placeholder='Search...' />

                  <ActivityTree
                    setDataAsPerCategory={this.setDataAsPerCategory}
                    {...this.props}
                  />
                  <ContentTree
                    setDataAsPerCategory={this.setDataAsPerCategory}
                    {...this.props} />
                </span>
                : null}
            </Grid.Column>
          }
        </Grid.Row>
      </Grid>




    );
  }
}
export default MyPracticeTreeMenu;